import * as service from './service'
export default {
  namespace: 'recommendAwardsRecords',
  state: {},
  effects: {
    * records ({ payload }, { call, put }) {
      const res = yield call(service.records, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
